
// components/common/Typography/Typography.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Typography as AntTypography } from 'antd'
import './typography.scss'

const { Title: AntTitle, Text: AntText, Paragraph: AntParagraph } = AntTypography

const Title = ({
  level = 1,
  children,
  className = '',
  ...props
}) => {
  const titleClass = `app-title app-title-${level} ${className}`
  
  return (
    <AntTitle
      level={level}
      className={titleClass}
      {...props}
    >
      {children}
    </AntTitle>
  )
}

Title.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5]),
  children: PropTypes.node,
  className: PropTypes.string
}

const Text = ({
  children,
  type,
  strong = false,
  disabled = false,
  mark = false,
  underline = false,
  delete: del = false,
  code = false,
  className = '',
  ...props
}) => {
  const textClass = `app-text ${className}`
  
  return (
    <AntText
      type={type}
      strong={strong}
      disabled={disabled}
      mark={mark}
      underline={underline}
      delete={del}
      code={code}
      className={textClass}
      {...props}
    >
      {children}
    </AntText>
  )
}

Text.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['secondary', 'success', 'warning', 'danger']),
  strong: PropTypes.bool,
  disabled: PropTypes.bool,
  mark: PropTypes.bool,
  underline: PropTypes.bool,
  delete: PropTypes.bool,
  code: PropTypes.bool,
  className: PropTypes.string
}

const Paragraph = ({
  children,
  className = '',
  ...props
}) => {
  const paragraphClass = `app-paragraph ${className}`
  
  return (
    <AntParagraph
      className={paragraphClass}
      {...props}
    >
      {children}
    </AntParagraph>
  )
}

Paragraph.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

const Typography = {
  Title,
  Text,
  Paragraph
}

export default Typography